// Header.js
import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import CompanySelect from "./CompanySelect";
import CompanyTitle from "./CompanyTitle";
import useStore from "hooks/useStore";

function Header({
  open,
  handleProfileMenuOpen,
  handleLogout,
  anchorEl,
  setAnchorEl,
  toggleDrawer,
}) {
  const isMenuOpen = Boolean(anchorEl);
  const isUserAdministrator = useStore((state) => state.isUserAdministrator)();
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleLogout}>Logout</MenuItem>
    </Menu>
  );

  return (
    <AppBar position="absolute" open={open}>
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer} // ← this toggles the store value
          sx={{ mr: 2, display: { md: "none" } }}
        >
          <MenuIcon />
        </IconButton>
        {isUserAdministrator && <CompanySelect open={open} />}
        {!isUserAdministrator && <CompanyTitle open={open} />}
        <Box sx={{ flexGrow: 1 }} />
        <IconButton
          edge="end"
          aria-label="account of current user"
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          color="inherit"
        >
          <AccountCircle fontSize="large" />
        </IconButton>
      </Toolbar>
      {renderMenu}
    </AppBar>
  );
}

export default Header;
